import { Link } from 'gatsby';
import { OutboundLink } from 'gatsby-plugin-gtag';
import { EuiSpacer } from '@elastic/eui';
import YoutubeVideo from 'components/Quick_Installation/WebUI_And_Firmware_Upgrade/YoutubeVideoCardUpdate';
import PrimaryBox from 'components/Quick_Installation/WebUI_And_Firmware_Upgrade/PrimaryBox';
import NavButtons from 'components/Quick_Installation/NavButtons';
import ForumBox from 'components/Quick_Installation/WebUI_And_Firmware_Upgrade/ForumBox';
import BreadCrumbs from 'components/Layout/BreadCrumbs';
import SEOHelmet from 'components/Layout/SEOHelmet';
import * as React from 'react';
export default {
  Link,
  OutboundLink,
  EuiSpacer,
  YoutubeVideo,
  PrimaryBox,
  NavButtons,
  ForumBox,
  BreadCrumbs,
  SEOHelmet,
  React
};